import "../css-files/navbar.css";
import ResumeView from "../components/resume-view.component";
import Background from "../components/resume-background.component";
const Resume = () => {
  return (
    <>
      <ResumeView />
      <Background />
    </>
  );
};

export default Resume;
